var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#279EDA",
    d: "M54,72H18C8.1,72,0,63.9,0,54V18C0,8.1,8.1,0,18,0h36c9.9,0,18,8.1,18,18v36C72,63.9,63.9,72,54,72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#279EDA",
    d: "M82.2,27.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.3,35.4c10.8-4.7,18-7.8,21.6-9.3c10.3-4.3,12.5-5,13.8-5.1c0.3,0,1,0.1,1.4,0.4s0.5,0.7,0.5,1 s0.1,1,0.1,1.5c-0.6,5.9-3,20.1-4.2,26.7C50,53.4,49,54.3,48,54.4c-2.2,0.2-3.8-1.4-5.9-2.8c-3.3-2.1-5.1-3.5-8.3-5.6 c-3.7-2.4-1.3-3.7,0.8-5.9c0.5-0.6,10-9.2,10.2-10c0-0.1,0-0.5-0.2-0.7s-0.5-0.1-0.8-0.1c-0.3,0.1-5.5,3.5-15.6,10.3 c-1.5,1-2.8,1.5-4,1.5c-1.3,0-3.9-0.8-5.8-1.4c-2.3-0.8-4.2-1.2-4-2.4C14.7,36.8,15.6,36.1,17.3,35.4L17.3,35.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c5c85820e2ef9d2779b95889da7cc6e3.svg";
export { ForwardRef as ReactComponent };